import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/user/bo_arrow_u.png'
import _imports_1 from '@/assets/user/bo_arrow_d.png'


const _withScopeId = n => (_pushScopeId("data-v-104fb66e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, "경찰청 YouTube", -1))
const _hoisted_5 = { class: "board_wrap bo_view_layer" }
const _hoisted_6 = { class: "bo_view" }
const _hoisted_7 = { class: "bo_view_tit" }
const _hoisted_8 = { class: "tit" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "bo_view_content" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "bo_video"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "bo_list_btns" }
const _hoisted_16 = {
  key: 0,
  class: "prev"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_18 = ["textContent"]
const _hoisted_19 = {
  key: 1,
  class: "next"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_21 = ["textContent"]
const _hoisted_22 = { class: "bo_view_btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString($setup.content.title), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString($setup.content.date), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (
                                $setup.content.fileLocation !== '' ||
                                $setup.content.fileLocation !== null ||
                                $setup.content.fileLocation !== undefined
                            )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!$setup.state.isVideoExt)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: $setup.content.fileLocation
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      ($setup.state.isVideoExt)
                        ? (_openBlock(), _createElementBlock("video", {
                            key: 1,
                            src: $setup.content.fileLocation
                          }, null, 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (
                                $setup.content.youtubeLink !== '' ||
                                $setup.content.youtubeLink !== null ||
                                $setup.content.youtubeLink !== undefined
                            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("iframe", {
                        width: "100%",
                        height: "100%",
                        src: $setup.content.youtubeLink,
                        frameborder: "0",
                        allowfullscreen: ""
                      }, null, 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                ($setup.content.prevIdx !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("span", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.prevPage($setup.content.prevIdx)))
                      }, [
                        _hoisted_17,
                        _createTextVNode(" 이전 글 ")
                      ]),
                      _createVNode(_component_router_link, {
                        to: "#",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.prevPage($setup.content.prevIdx)))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", {
                            textContent: _toDisplayString($setup.content.prevTitle)
                          }, null, 8, _hoisted_18)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                ($setup.content.nextIdx !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("span", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.nextPage($setup.content.nextIdx)))
                      }, [
                        _hoisted_20,
                        _createTextVNode(" 다음 글 ")
                      ]),
                      _createVNode(_component_router_link, {
                        to: "#",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.nextPage($setup.content.nextIdx)))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", {
                            textContent: _toDisplayString($setup.content.nextTitle)
                          }, null, 8, _hoisted_21)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_router_link, {
                to: "#",
                class: "list",
                onClick: $setup.goToList
              }, {
                default: _withCtx(() => [
                  _createTextVNode("목록")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}